import api from "./api";

export const aiKnowledgeApi = {
  // Listar todos
  list: (params) => api.get("/ai-knowledge", { params }),

  // Buscar
  search: (query, system) =>
    api.get("/ai-knowledge/search", { params: { q: query, system } }),

  // Obter por ID
  get: (id) => api.get(`/ai-knowledge/${id}`),

  // Criar
  create: (data) => api.post("/ai-knowledge", data),

  // Atualizar
  update: (id, data) => api.put(`/ai-knowledge/${id}`, data),

  // Excluir
  delete: (id) => api.delete(`/ai-knowledge/${id}`),

  // Ativar/Desativar
  toggleActive: (id) => api.patch(`/ai-knowledge/${id}/toggle-active`),

  // Listar sistemas
  getSystems: () => api.get("/ai-knowledge/systems"),

  // Sugerir tags
  suggestTags: (data) => api.post("/ai-knowledge/suggest-tags", data),

  // Enviar print de uma etapa
  uploadStepImage: (formData) =>
    api.post("/ai-knowledge/upload-step-image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
}; 
